import { concat } from '@ember/helper';
import { service } from '@ember/service';
import AppHeaderBanner from './header/banner';
import { PhArrowSquareOut } from 'ember-phosphor-icons';
import Component from '@glimmer/component';
import TioHeaderMenuButton from 'tio-common/components/tio/header/menu-button';
import type SessionContextService from 'tio-employee/services/session-context';
import type SideDrawerService from 'tio-common/services/side-drawer';
import { t } from 'ember-intl';
import type PartnerService from 'tio-employee/services/partner';
interface AppHeaderSignature {
  Args: {
    /** Hides the company banner while retaining the partner link and mobile menu button. */
    hideBanner?: boolean;
  };
  Element: HTMLHeadElement;
}
export default class AppHeaderComponent extends Component<AppHeaderSignature> {
  @service declare sessionContext: SessionContextService;
  @service declare sideDrawer: SideDrawerService;
  @service declare partner: PartnerService;
  get showBanner() {
    return !this.args.hideBanner;
  }
  toggleDrawer = () => {
    this.sideDrawer.toggleDrawer();
  };
  get partnerUrlString() {
    return this.partner.partnerUrlString;
  }
  get partnerName() {
    return this.partner.company?.name || '';
  }
  get partnerPromptTranslationKey() {
    return (
      this.partner.returnToPartnerUrlObj?.promptTranslationKey || 'instride.looking_for_coverage'
    );
  }
  <template>
    <header class="isolate top-0 tio-bg-surface tio-fg-primary z-5" ...attributes>
      <div class="tio-row-between app-page-gutter">
        <TioHeaderMenuButton @onClick={{this.toggleDrawer}} class="lg:hidden" />
        {{#if this.showBanner}}
          <AppHeaderBanner @company={{this.sessionContext.currentCompany}} />
        {{/if}}
        {{#if this.partnerUrlString}}
          <div class="tio-flex-tight h-14 header-right text-sm items-end">
            <div class="tio-row-tight flex-row text-right">
              <p>{{t this.partnerPromptTranslationKey partner=this.partnerName}}</p>
              <a
                class="tio-header-partner-link underline underline-offset-2 tio-fg-info hover:tio-fg-info-body tio-row-extra-tight"
                href={{this.partnerUrlString}}
                target="_blank"
                rel="noopener noreferrer"
              >{{concat this.partnerName " " (t "dashboard")}}<PhArrowSquareOut @size={{16}} /></a>
            </div>
          </div>
        {{/if}}
      </div>
    </header>
  </template>
}
